var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalIncome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.926,
    height: 19.951,
    viewBox: "0 0 28.926 19.951",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_405-Money",
    "data-name": "405-Money",
    transform: "translate(0 -5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27770",
    "data-name": "Path 27770",
    d: "M17.155,23.951H1V6H27.926v9.873",
    fill: "none",
    stroke: "#4a95cd",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3108",
    "data-name": "Ellipse 3108",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(10 10.951)",
    fill: "none",
    stroke: "#4a95cd",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27771",
    "data-name": "Path 27771",
    d: "M7.693,10H5v2.693",
    transform: "translate(-0.41 -0.41)",
    fill: "none",
    stroke: "#4a95cd",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27772",
    "data-name": "Path 27772",
    d: "M26.693,12.693V10H24",
    transform: "translate(-2.357 -0.41)",
    fill: "none",
    stroke: "#4a95cd",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27773",
    "data-name": "Path 27773",
    d: "M5,19v2.693H7.693",
    transform: "translate(-0.41 -1.332)",
    fill: "none",
    stroke: "#4a95cd",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27774",
    "data-name": "Path 27774",
    d: "M22,22.693l2.693,2.693L30.078,20",
    transform: "translate(-2.152 -1.435)",
    fill: "none",
    stroke: "#4a95cd",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalIncome);
export default __webpack_public_path__ + "static/media/TotalIncome.f8db923e9d7cb2a73bfa8ed3302ecd4b.svg";
export { ForwardRef as ReactComponent };